// DonateBanner.jsx
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom.scss';
import PayPalDonateSdkButton from './PayPalDonateSdkButton';
import { getHost } from './config';

const DonateBanner = () => {
    const location = useLocation();
    const [authToken, setAuthToken] = useState(() =>
        typeof window !== 'undefined' ? localStorage.getItem('authToken') : null
    );

    useEffect(() => {
        setAuthToken(localStorage.getItem('authToken'));

        const onStorage = (e) => {
            if (e.key === 'authToken' || e.key === null) {
                setAuthToken(localStorage.getItem('authToken'));
            }
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, [location.pathname]);

    if (!authToken) {
        return null;
    }

    return (
        <div className="donate-banner w-100">
            <div className="donate-banner-inner container-fluid px-3 py-2">
                <p className="donate-banner-msg mb-0 small">
                    Στήριξε το teachers-app.com και βοήθησε να συνεχίσουμε την προσπάθειά μας.
                </p>
                <div className="donate-banner-paypal">
                    <PayPalDonateSdkButton
                        key={authToken}
                        authToken={authToken}
                        getHost={getHost}
                        compact
                        donationSource="banner"
                        requireAuthForComplete
                        fallbackCustomFromJwt
                        returnPathFromCurrentPage
                    />
                </div>
            </div>
        </div>
    );
};

export default DonateBanner;
